<template>
    <div class="cooperation-page">
        <div class="home-container" :class="{ 'white-bg': showProductList }">
            <div class="logo-container" :class="{ 'white-bg': showProductList }">
                <div class="menu-btn" @click="toggleMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="logo-wrapper">
                    <img src="../assets/logo.png" alt="" class="logo">
                </div>
                <div class="nav-links" :class="{ 'nav-active': isMenuOpen }">
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="navigateTo('/')">
                        <span>首页</span>
                    </div>
                    <div class="nav-item nav-item3" :class="{ 'active-product': showProductList }"
                        @click="toggleProductList">
                        <span>雾曼技术和产品</span>
                    </div>
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="navigateTo('/Dynamic')">
                        <span>雾曼动态</span>
                    </div>
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="navigateTo('/about')">
                        <span>关于雾曼</span>
                    </div>
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="navigateTo('/contact')">
                        <span>联系雾曼</span>
                    </div>
                    <div class="nav-item nav-item2" :class="{ 'dark-text': showProductList }" @click="FisMobile()">
                        <span>成为合伙人</span>
                    </div>
                    <div class="mobile-consult-btn" @click="handleConsult">需求咨询</div>
                </div>
                <div class=" consult-button" @click="handleConsult">需求咨询</div>

            </div>
            <div class="info-container">
                <div class="page-title">成为雾曼商业合伙人</div>
            </div>
        </div>
        <div class="tab-container">
            <div class="tab-wrapper">
                <div class="tab-item" :class="{ 'active': activeTab === 'operation' }"
                    @click="scrollToContent('operation')">
                    运营中心</div>
                <div class="tab-item" :class="{ 'active': activeTab === 'service' }"
                    @click="scrollToContent('service')">服务中心
                </div>
                <div class="tab-item" :class="{ 'active': activeTab === 'protection' }"
                    @click="scrollToContent('protection')">植保中心</div>
            </div>
        </div>
        <div class="content-wrapper">
            <div class="partner-card" id="operation">
                <div class="card-title">
                    成为<span class="highlight">运营中心</span>合伙人
                </div>
                <div class="divider"></div>
                <div v-html="operationPartnerIntro" class="operation-partner-intro"></div>
                <div class="contact-btn" @click="$router.push('/contact')">联系我们</div>
            </div>
            <div class="partner-card" id="service">
                <div class="card-title">
                    成为<span class="highlight">服务中心</span>合伙人
                </div>
                <div class="divider"></div>
                <div v-html="servicePartnerIntro" class="operation-partner-intro"></div>
                <div class="contact-btn" @click="$router.push('/contact')">联系我们</div>
            </div>
            <div class="partner-card" id="protection">
                <div class="card-title">
                    成为<span class="highlight">植保中心</span>合伙人
                </div>
                <div class="divider"></div>
                <div class="protection-content">
                    <div class="protection-section">
                        <div class="section-header">
                            <div class="section-line"></div>
                            <div class="section-title">植保站</div>
                        </div>
                        <div class="section-content">
                            <div v-html="plantProtectionStation" class="operation-partner-intro"></div>
                        </div>
                    </div>
                    <div class="protection-section">
                        <div class="section-header">
                            <div class="section-line"></div>
                            <div class="section-title">植保兵</div>
                        </div>
                        <div class="section-content">
                            <div v-html="plantProtectionSoldier" class="operation-partner-intro"></div>
                        </div>
                    </div>
                </div>
                <div class="contact-btn" @click="$router.push('/contact')">联系我们</div>
            </div>
            <div class="coop-image-container">
                <ChinaMap2 />

            </div>
            <div class="coop-image-container">
                <img src="../assets/coop/coop3.png" alt="" class="coop-image">
            </div>
        </div>
        <product-list v-if="showProductList" :top="70" style="z-index: 1000;position: absolute;"></product-list>
        <!--<div class="Aichat">
            <ChatWidget :defaultOpen="isOpen" />
            <div class="Aitext" @click="openChat">AI小曼</div>
        </div>-->
        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import ProductList from '@/components/ProductList.vue'
import ChinaMap2 from '@/components/ChinaMap2.vue';
export default {
    name: 'HomeHeader',
    components: {
        Footer,
        ProductList,
        ChinaMap2
    },
    data() {
        return {
            newsList: [],
            servicePartnerIntro: "",
            operationPartnerIntro: "",
            plantProtectionStation: "",
            plantProtectionSoldier: "",
            isMenuOpen: false,
            showProductList: false,
            activeTab: 'operation',
        }
    },
    created() {
        this.getNewsDetail(643905914351685)
    },
    methods: {
        FisMobile() {
            this.showProductList = false;
        },
        openChat() {
            this.isOpen = !this.isOpen
        },
        getNewsDetail(id) {
            // 先获取文章列表
            this.$http.get(`/cms/content/front-list?pageNum=1&pageSize=10&catalogId=${id}`).then(res => {
                if (res.code === 200 && res.data.rows.length > 0) {
                    // 存储文章列表
                    this.newsList = res.data.rows;

                    // 对每篇文章进行详情请求
                    this.newsList.forEach(article => {
                        this.$http.get(`/cms/content/detail/${id}/article/${article.contentId}`).then(detailRes => {
                            if (detailRes.code === 200) {
                                // 根据文章标题找到对应的区域并更新内容
                                switch (article.title) {
                                    case "成为服务中心合伙人":
                                        this.servicePartnerIntro = detailRes.data.contentHtml;
                                        break;
                                    case "成为运营中心合伙人":
                                        this.operationPartnerIntro = detailRes.data.contentHtml;
                                        break;
                                    case "植保站":
                                        this.plantProtectionStation = detailRes.data.contentHtml;
                                        break;
                                    case "植保兵":
                                        this.plantProtectionSoldier = detailRes.data.contentHtml;
                                        break;
                                }

                            }
                        }).catch(error => {
                            console.error('获取文章详情失败:', error);
                        });
                    });
                }
            }).catch(error => {
                console.error('获取文章列表失败:', error);
            });
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        toggleProductList() {
            this.showProductList = !this.showProductList;

        },
        navigateTo(path) {
            if (path !== '/product') {
                this.showProductList = false;
            }
            this.$router.push(path);
            this.isMenuOpen = false;
        },
        scrollToContent(tab) {
            this.activeTab = tab;
            const element = document.getElementById(tab);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },
        handleConsult() {
            this.$router.push('/contact').then(() => {
                setTimeout(() => {
                    window.scrollTo({
                        top: 1000,
                        behavior: 'smooth'
                    });
                }, 500);
            });
        }
    }
}
</script>

<style scoped>
.home-container {
    width: 100%;
    height: 380px;
    background-color: #000;
    background-image: url("../assets/coop/coop1.png");
    background-size: cover;
    background-position: center;
}

.logo-container {
    width: 100%;
    height: 70px;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(3px);
    padding: 0 55px;
    display: flex;
    align-items: center;
    position: relative;
}

.logo-wrapper {
    position: absolute;
}

.logo {
    width: 251px;
    height: 32px;
}

.nav-links {
    display: flex;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    text-align: center;
    margin: auto;
    height: 68px;
    line-height: 70px;
    cursor: pointer;
}

.nav-item {
    padding: 15px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 15px;
}

.nav-item2 {
    border-bottom: 2px solid #FFFFFF;
}

.consult-button {
    background: #FFFFFF;
    border-radius: 17px;
    width: 96px;
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    color: #0A2E43;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 54px;
}

/* .info-container {
    width: 1120px;
    margin: auto;
    margin: 233px;
} */

.info-box {
    width: calc(367px - 13px - 13px);
    padding: 0 13px;
    height: 48px;
    background: #FFFFFF;
    border-radius: 8px;
    line-height: 48px;
}

.info-title {
    font-size: 20px;
    color: #041214;
    font-weight: 500;
    font-style: normal;
}

.info-subtitle {
    color: #041214;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
}

.info-text {
    font-weight: 500;
    font-size: 56px;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    width: 1120px;
}

.contact-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.contact-label {
    color: #FFFFFF;
    font-size: 14px;
    margin-left: 8px;
}

.contact-button {
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    height: 48px;
    width: 158px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.contact-button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.contact-button img {
    width: 16px;
    height: 16px;
}

.contact-text,
.contact-icon {
    display: none;
}

.operation-partner-intro ::v-deep p {
    margin-bottom: 0;
}

.cooperation-page {
    background: #F5F6F7;
}

.page-title {
    color: #FFFFFF;
    font-size: 52px;
    font-weight: 500;
    margin: 96px 0 0 213px;
}

.tab-container {
    width: 100%;
    height: 53px;
    background: #FFFFFF;
}

.tab-wrapper {
    display: flex;
    justify-content: center;
}

.tab-item {
    width: 96px;
    text-align: center;
    line-height: 53px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.tab-item.active {
    color: #B80708;
    border-bottom: 2px solid #B80708;
}

.tab-item:hover {
    color: #B80708;
}

.content-wrapper {
    background: #fff;
    padding: 0 0 46px 0;
}

.partner-card {
    width: calc(1345px - 64px);
    margin: 37px auto;
    background: #FFFFFF;
    border-radius: 11px;
    padding: 0 32px;
    transition: opacity 0.3s ease;
}

.card-title {
    font-size: 22px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    padding: 30px 0 15px 0;
}

.highlight {
    color: #B80708;
}

.divider {
    border: 1px solid rgba(0, 0, 0, 0.1);
    height: 1px;
    width: 100%;
}

.contact-btn {
    background: #B80708;
    border-radius: 7px;
    width: 116px;
    height: 37px;
    margin: 24px 0 0 0;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 600;
    text-align: center;
    line-height: 37px;
}

.operation-partner-intro ::v-deep p {
    margin-bottom: 0;
}

.protection-content {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 20px;
}

.protection-section {
    flex: 1;
    min-width: 280px;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.section-line {
    height: 15px;
    width: 3px;
    background: #B80708;
}

.section-title {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    padding-left: 8px;
}

.section-content {
    margin-top: 20px;
}

/* 添加移动端适配样式 */
@media screen and (max-width: 768px) {
    .nav-item3 {
        display: none;
    }

    .logo-container {
        height: 50px;
        padding: 0 15px;
    }

    .logo {
        width: 150px;
        height: 20px;
    }

    .menu-btn {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 25px;
        height: 20px;
        position: absolute;
        right: 15px;
        z-index: 1000;
    }

    .menu-btn span {
        width: 100%;
        height: 2px;
        background-color: #fff;
        transition: all 0.3s ease;
    }

    .nav-links {
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        height: 0;
        background: rgba(0, 0, 0, 0.9);
        flex-direction: column;
        overflow: hidden;
        transition: height 0.3s ease;
        margin: 0;
        padding: 0;
        z-index: 999;
    }

    .nav-links.nav-active {
        height: calc(100vh - 50px);
        overflow-y: auto;
    }

    .nav-item {
        width: 100%;
        padding: 0;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        margin: 0;
    }

    .nav-item span {
        display: block;
        width: 100%;
        text-align: left;
    }

    .nav-item2 {
        border-bottom-width: 1px;
    }

    .mobile-consult-btn {
        background: #FFFFFF;
        color: #0A2E43;
        margin: 10px 20px;
        border-radius: 17px;
        height: 40px;
        line-height: 40px;
    }

    .page-title {
        font-size: 32px;
        margin: 60px 0 0 20px;
    }

    .partner-card {
        width: calc(100% - 30px);
        margin: 15px auto;
        padding: 0 15px;
    }

    .content-wrapper img {
        width: 100% !important;
        height: auto !important;
    }

    .content-wrapper>div {
        width: 100% !important;
        height: auto !important;
        margin: 20px auto !important;
    }

    .coop-image-container {
        width: 95%;
        margin: 20px auto;
    }

    .consult-button {
        display: none;
    }
}

.coop-image-container {
    width: 90%;
    max-width: 1255px;
    margin: 40px auto;
}

.coop-image {
    width: 100%;
    height: auto;
    object-fit: contain;
}

.white-bg {
    background: #FFFFFF !important;
}

.dark-text {
    color: #0A2E43 !important;
}

.active-product {
    color: #B80708 !important;
    border-bottom: 2px solid #B80708;
}

.nav-item {
    padding: 0 20px;
    position: relative;
}

/* 默认显示移动端按钮样式 */
.mobile-consult-btn {
    background: #FFFFFF;
    color: #0A2E43;
    margin: 10px 20px;
    border-radius: 17px;
    height: 40px;
    line-height: 40px;
}

/* 在非移动端隐藏 */
@media screen and (min-width: 769px) {
    .mobile-consult-btn {
        display: none;
    }
}
</style>